import ProductDialogSelector from './product-dialog-selector.vue'

ProductDialogSelector.install = function (Vue) {
	Vue.component(ProductDialogSelector.name, ProductDialogSelector);
}

export default ProductDialogSelector;